
import Vue, {VueConstructor} from "vue";
import qs from "query-string";
const parseURL = (url:string) =>{
  return ParseURL(url);
};
declare module "vue/types/vue" {
  interface Vue {
    $parseURL: typeof parseURL
  }
}

Vue.use((vue:VueConstructor)=>{
  vue.prototype.$parseURL=parseURL;
});

export default function ParseURL(url: string): string{
   if(url.indexOf("hotelId=")==-1){
    const query = qs.parse(location.search) as any;
    if(url.indexOf("?")==-1){
      url = url+"?";
    }
    url = url+"hotelId="+query.hotelId;
   }
   return url;
}